import React from 'react';
import Plans from '../component/plan/Plans';
import ComponenetHeader from '../component/common/ComponenetHeader';
import planIcon1 from '../assets/plan_icon1.webp';
import planIcon2 from '../assets/plan_icon2.webp';
import planIcon3 from '../assets/plan_icon3.webp';
import { Helmet } from 'react-helmet';

const PlanPage = () => {
  return (
    <>
      <ComponenetHeader
        name={'Plans'}
      />

      <Helmet>
        <link rel="canonical" href="/plans" />
        <title>Smart Trailer Repair Service Plans – Affordable. Fast. Easy</title>
        <meta name="keywords" content="trailer repair service, trailer repairs,truck service near me,trailer repair near me,Reefer Repair,truck and trailer repair shop near me, heavy duty truck repair, trailer repair shops"/>
        <meta name="description" content="Don’t let trailer issues ruin your route. Our smart trailer repair service plans offer unbeatable value, 24/7 support, and fast response. Start your plan today!"/>
        <meta property="og:title" content="Smart Trailer Repair Service Plans – Affordable. Fast. Easy" />
        <meta property="og:description" content="Don’t let trailer issues ruin your route. Our smart trailer repair service plans offer unbeatable value, 24/7 support, and fast response. Start your plan today!"/>
      </Helmet>

      <section className='new_plan-section'>
        <div className='container'>
          <div className='row justify-content-center'>
            <div className='col-md-10'>
              <div className='plan_new_content'>
                <h1>How does Online Road Services pricing work?</h1>
                <p>Our platform provides vendors with a flexible pay-as-you-go pricing model. You only pay for the
                  services <br />you choose to offer and the time you utilize our platform—no long-term contracts <br />or
                  complicated terms involved.</p>
              </div>
              <div className='plan_new_highlight'>
                <p>Similar to utility bills like water or electricity, you’re billed based on actual usage,
                  with no extra fees or termination charges once you stop using the services. Discover how partnering with us can
                  streamline your costs and help grow your business. Contact us for a tailored estimate.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className='new_plan-section_two'>
        <div className='container'>
          <div className='row'>
            <div className='col-md-12'>
              <div className='plan_new_content_two'>
                <h2>How do you pay for Online Road Services?</h2>
              </div>
            </div>

            <div className='col-md-4 mb-md-0 mb-3'>
              <div className='new_plan_card h-100'>
                <img src={planIcon1} className='img-fluid' alt='Pay-as-You-Go' />
                <h3>Pay-as-You-Go</h3>
                <p>
                  Our pay-as-you-go model lets you scale your trailer repairs and other
                  services based on actual needs, avoiding over commitments and minimizing
                  capacity risks. With flexible pricing, you can quickly adapt to changes
                  and find the right truck service near you, including <a href="https://onlineroadservices.com/about">heavy duty truck
                    repair</a>, ensuring your business remains agile and competitive in a dynamic
                  market. Stay responsive without exceeding your budget.
                </p>
              </div>
            </div>

            <div className='col-md-4 mb-md-0 mb-3'>
              <div className='new_plan_card h-100'>
                <img src={planIcon2} className='img-fluid' alt='Save-with-Commitment' />
                <h3>Save with Commitment</h3>
                <p>
                OnlineRoadServices platform offers savings opportunities when you commit to
                providing services. Whether you specialize in Reefer Repair or other roadside
                services, by committing to a specific level of service usage over a one- or
                three-year period, you can enjoy reduced costs compared to pay-as-you-go
                pricing. With this model, you can expect predictable costs while at the same
                time maximizing your vendor's profit opportunities. Start partnering with us today.
                </p>
              </div>
            </div>

            <div className='col-md-4 mb-md-0 mb-3'>
              <div className='new_plan_card h-100'>
                <img src={planIcon3} className='img-fluid' alt='Pay-less-by-using-more' />
                <h3>Pay less by using more</h3>
                <p>
                  At your truck and trailer repair shop near you, enjoy volume-based discounts
                  that lower your cost per service as you increase bookings. Our tiered pricing
                  ensures the more services you provide, the more you save. With flexible plans
                  designed to scale with your business, you can grow efficiently while keeping
                  costs low. Whether expanding your reach or working with other <a href="https://onlineroadservices.com/">trailer repair
                    shops</a>, save more with each job.
                </p>
              </div>
            </div>

          </div>
        </div>
      </section>

      <Plans />

    </>
  );
};

export default PlanPage;
